export default __webpack_public_path__ + "static/media/rwanda.77833b6c.svg";